module.exports = __webpack_public_path__ + "static/media/louis-van-beethoven.7e92a271.webp";